﻿
$(".language-picker").click(
    function () {
        var self = $(this).parent();
        self.siblings().find(".dropdown-content").slideUp();
        self.find('.dropdown-language').slideToggle();
    }
);

$(document).ready(function () {
    var test = () => $(document).scrollTop() > 50;
    if (document.body.classList.contains("ripple")) {
        test = () => $(document).scrollTop() > window.innerHeight;
    }

    $(window).scroll(function () {
        if (test()) {
            $("body").addClass("header-sticky");
        } else {
            $("body").removeClass("header-sticky");
        }
    });
});